import React, { useEffect, useState } from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { staticLinks } from 'shared/linkBuilder'
import { AuthFailed } from './AuthFailed'

import Loader from 'front-end/src/components/common/loader/Loader'

import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'
import { OAUTH_NEXT_REDIRECT_STATE_PARAM_KEY } from 'shared/oauth'

/**
 * this is a route just for OAUTH or using login-as-user feature, regular logins get their session in PrivateRoute
 * this route is special-it is the only one that needs to be in both private and public schemas because otherwise a user logging in might see a short flash of "Page not found"
 */
export const AuthSuccess: React.FC<
  RouteComponentProps<{
    sid: string
  }>
> = () => {
  const [failed, setFailed] = useState(false)
  // used for preventing multiply redirecting query.next->home->query.next
  const isRedirecting = React.useRef(false)

  const { data, loading } = usePublicApiSession()

  const session = data?.session

  useEffect(() => {
    if (!loading && session === null) {
      setFailed(true)
    }
  }, [session, loading])

  if (loading) {
    return <Loader />
  }
  if (session && !isRedirecting.current) {
    const search = new URLSearchParams(window.location.search)

    // prevents redirect to home page, while redirecting to next route
    isRedirecting.current = true

    const nextRoute = search.get(OAUTH_NEXT_REDIRECT_STATE_PARAM_KEY)
    if (nextRoute) {
      return <Redirect to={nextRoute} />
    }
    return <Redirect to={staticLinks.home} />
  }
  if (failed) {
    return <AuthFailed />
  }
  return null
}
